import React from 'react';
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import MatchingDetailsCard from './matchingDetailsCard';
import HEADER_IMG from './images/header.svg';
import JOB_ICON from './images/jobRoleIcon.svg';
import LOCATION_ICON from './images/locationIcon.svg';
import EMAIL_ICON from './images/emailIcon.svg';
import PHONE_ICON from './images/phoneIcon.svg';
import clsx from 'clsx';
import { useCommonStyles } from './styles';
import LINKEDIN_ICON from './images/linkedinIcon.svg';
import GITHUB_ICON from './images/githubIcon.svg';

const useStyles = makeStyles((theme) => ({
  headerCardContainer: {
    background: (props) =>
      theme.palette.matchingDetailsPage[props.mode].textPrimary,
    height: 124,
    color: (props) =>
      theme.palette.matchingDetailsPage[props.mode].textSecondary,
    position: 'relative',
  },
  headerImg: {
    backgroundImage: (props) =>
      `linear-gradient(89deg, ${
        theme.palette.matchingDetailsPage[props.mode].textPrimary
      } 0%, rgba(0, 0, 0, 0.00) 100%), url(${HEADER_IMG})`,
    backgroundRepeat: 'repeat',
    height: '100%',
    width: '60%',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  headerTitle: {
    color: '#FFF',
    paddingBottom: 8,
  },
}));

const MatchingDetailsHeader = ({
  name = '',
  jobRole = '',
  location = '',
  email = '',
  phone = '',
  linkedinProfile = '',
  githubProfile = '',
  mode,
}) => {
  const classes = useStyles({ mode });
  const commonClasses = useCommonStyles({ mode });

  const openInNewTab = (url) => {
    window.open(url, '_blank').focus();
  };

  return (
    <MatchingDetailsCard rootClass={classes.headerCardContainer} mode={mode}>
      <div className={classes.headerImg} />
      <Grid container>
        <Grid item xs={5}>
          <Grid container>
            <Grid item xs={12}>
              <Box display={'flex'}>
                <Typography
                  classes={{
                    root: clsx(commonClasses.fontLarge, classes.headerTitle),
                  }}
                >
                  {name}
                </Typography>
                {linkedinProfile && (
                  <img
                    src={LINKEDIN_ICON}
                    style={{ marginLeft: 8, cursor: 'pointer' }}
                    alt="Linkedin profile"
                    onClick={() => openInNewTab(linkedinProfile)}
                  />
                )}
                {githubProfile && (
                  <img
                    src={GITHUB_ICON}
                    style={{ marginLeft: 8, cursor: 'pointer' }}
                    alt="Github profile"
                    onClick={() => openInNewTab(githubProfile)}
                  />
                )}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box margin={'8px 0'}>
                <Box display={'flex'} marginBottom={'8px'}>
                  <img
                    src={JOB_ICON}
                    alt="Job Role"
                    style={{ marginRight: 8, cursor: 'pointer' }}
                  />
                  <Typography classes={{ root: commonClasses.fontMedium }}>
                    {jobRole}
                  </Typography>
                </Box>
                <Box display={'flex'}>
                  <img
                    src={LOCATION_ICON}
                    alt="Location"
                    style={{ marginRight: 8, cursor: 'pointer' }}
                  />
                  <Typography classes={{ root: commonClasses.fontMedium }}>
                    {location}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box margin={'8px 0'}>
                <Box display={'flex'} marginBottom={'8px'}>
                  <img
                    src={EMAIL_ICON}
                    alt="Email"
                    style={{ marginRight: 8, cursor: 'pointer' }}
                  />
                  <Typography classes={{ root: commonClasses.fontMedium }}>
                    {email}
                  </Typography>
                </Box>
                <Box display={'flex'}>
                  <img
                    src={PHONE_ICON}
                    alt="Phone"
                    style={{ marginRight: 8, cursor: 'pointer' }}
                  />
                  <Typography classes={{ root: commonClasses.fontMedium }}>
                    {phone}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MatchingDetailsCard>
  );
};

export default MatchingDetailsHeader;
